var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Fetches details of currently viewed patient
import usePatientId from "./usePatientId";
import { useGetPatientQuery } from "./api";
export default () => {
    const _a = usePatientId(), { patientId } = _a, idRest = __rest(_a, ["patientId"]);
    const _b = useGetPatientQuery(patientId), { data: patient, isLoading } = _b, queryRest = __rest(_b, ["data", "isLoading"]);
    return Object.assign(Object.assign({ patientId, patient: patient, isLoading }, idRest), queryRest);
};
